export default "__VITE_ASSET__CT3c06DJ__"